var _ellipse, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimeArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 42,
    viewBox: "0 0 41 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 20,
    cy: 21,
    rx: 16,
    ry: 15.5,
    fill: "#54BB9C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 14.167V21.0003L23.9167 24.417",
    stroke: "#151617",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.2156 19.1902C4.15963 19.7397 4.55967 20.2304 5.10911 20.2864C5.65855 20.3424 6.14933 19.9423 6.2053 19.3929L4.2156 19.1902ZM7.00391 25.7818C6.81442 25.263 6.24027 24.9961 5.72151 25.1856C5.20275 25.3751 4.93583 25.9492 5.12532 26.468L7.00391 25.7818ZM4.21045 34.6666C4.21045 35.2188 4.65816 35.6666 5.21045 35.6666C5.76273 35.6666 6.21045 35.2188 6.21045 34.6666H4.21045ZM5.21045 26.1249V25.1249C4.65816 25.1249 4.21045 25.5726 4.21045 26.1249H5.21045ZM13.7521 27.1249C14.3044 27.1249 14.7521 26.6772 14.7521 26.1249C14.7521 25.5726 14.3044 25.1249 13.7521 25.1249V27.1249ZM6.2053 19.3929C6.94631 12.1183 13.0303 6.55908 20.3421 6.47556L20.3193 4.47569C11.9902 4.57083 5.0597 10.9035 4.2156 19.1902L6.2053 19.3929ZM20.3421 6.47556C27.6539 6.39205 33.8633 11.8108 34.7703 19.0666L36.7548 18.8186C35.7217 10.5532 28.6484 4.38056 20.3193 4.47569L20.3421 6.47556ZM34.7703 19.0666C35.6773 26.3224 30.9928 33.1029 23.8854 34.8218L24.3555 36.7658C32.4518 34.8077 37.788 27.0839 36.7548 18.8186L34.7703 19.0666ZM23.8854 34.8218C16.778 36.5407 9.5128 32.6502 7.00391 25.7818L5.12532 26.468C7.98327 34.292 16.2593 38.7238 24.3555 36.7658L23.8854 34.8218ZM6.21045 34.6666V26.1249H4.21045V34.6666H6.21045ZM5.21045 27.1249H13.7521V25.1249H5.21045V27.1249Z",
    fill: "#151617"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeArrow);
export default __webpack_public_path__ + "static/media/time-arrow.09c71a6dd9fa4166874f5ed06e363cda.svg";
export { ForwardRef as ReactComponent };